
import { useNavigate } from 'react-router-dom';
import { useToast } from '@/components/ui/use-toast';
import { useAuth } from '@/context/AuthContext';
import { startChatWithSeller } from '@/lib/actions/chatActions';

export const useMessageSeller = (productId: string | number, sellerId?: string) => {
  const navigate = useNavigate();
  const { toast } = useToast();
  const { user, isAuthenticated } = useAuth();
  
  // Handle message button click
  const handleMessageSeller = async (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    
    if (!isAuthenticated || !user) {
      toast({
        title: 'Kërkohet autentifikim',
        description: 'Ju lutemi identifikohuni për të kontaktuar shitësin.',
        variant: 'destructive',
      });
      navigate('/auth');
      return;
    }
    
    // Ensure we have a valid seller ID
    if (!sellerId || sellerId === 'undefined') {
      toast({
        title: 'Gabim',
        description: 'Të dhënat e shitësit mungojnë. Provoni përsëri më vonë.',
        variant: 'destructive',
      });
      return;
    }
    
    // Check if this is the user's own listing
    if (user.id === sellerId) {
      toast({
        title: 'Nuk mund të dërgoni mesazh',
        description: 'Ky është produkti juaj',
        variant: 'destructive',
      });
      return;
    }

    try {
      // Now we ensure a valid seller ID is passed to the function
      const chatId = await startChatWithSeller(
        user.id,
        sellerId,
        Number(productId)
      );
      
      if (chatId) {
        // Navigate to messages page with the specific chat selected
        navigate(`/messages?chat=${chatId}`);
      } else {
        toast({
          title: 'Gabim',
          description: 'Nuk mund të fillojë bisedën',
          variant: 'destructive',
        });
      }
    } catch (error) {
      toast({
        title: 'Gabim',
        description: 'Ndodhi një gabim gjatë nisjes së bisedës',
        variant: 'destructive',
      });
    }
  };

  return handleMessageSeller;
};
